import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL_BASE || "";

const api = axios.create({
  baseURL: API_URL,
});

// Automatically attach JWT token and active store ID to every request
api.interceptors.request.use(
  (config) => {
    const raw = localStorage.getItem("user");
    if (raw) {
      try {
        const user = JSON.parse(raw);
        if (user?.accessToken) {
          config.headers.Authorization = `Bearer ${user.accessToken}`;
        }
      } catch (_) {
        // ignore malformed JSON
      }
    }

    // Attach the active store ID from localStorage
    const activeStoreId = localStorage.getItem("activeStoreId");
    if (activeStoreId) {
      config.headers["x-store-id"] = activeStoreId;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Redirect to /login on 401/403 (token expired or missing)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      // Don't redirect if we're already on the login/register page
      const path = window.location.pathname;
      if (path !== "/login" && path !== "/register") {
        localStorage.removeItem("user");
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default api;
